import { createFileRoute } from '@tanstack/react-router'
import HomePage from '@/routes/features/home/pages/HomePage'

// The workspace root is Home (design 1d). Inbox lives at /$workspaceSlug/tasks.
export const Route = createFileRoute('/_AppWrapper/_AppLayout/$workspaceSlug/')(
  {
    component: HomePage,
  },
)
